




































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Thdata from "../../../store/entities/thdata";
import Echarts from "./Echarts.vue";
import EchartsHumi from "./Echarts.vue";
import PageRequest from "@/store/entities/page-request";
class PageThRealTimeDataRequest extends PageRequest {
  AddTime: Date=new Date();
  mac: string;
  mintemp:number;
  maxtemp:number;
  minhumi:number;
  maxhumi:number;
}
@Component({
  components: { Echarts,EchartsHumi },
})

export default class AnalyseThrealtimedata extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Date}) AddTime: Date;
   @Prop({ type: String}) mac: string;
   @Prop({ type: Number}) mintemp: number;
   @Prop({ type: Number}) maxtemp: number;
   @Prop({ type: Number}) minhumi: number;
   @Prop({ type: Number}) maxhumi: number;
   @Prop({type:String}) locationName:number;
  pagerequest: PageThRealTimeDataRequest = new PageThRealTimeDataRequest();
  componentKey: number = 10;
  componentKeyhumi:number=10;
  datalist = [];
  legenddata: string = "";
  xAxisdata: string = "";
  seriesdata: string = "";
  humiseriesdata: string = "";
  yAxisdata:string="";
  serieslist = [];
  humiserieslist = [];
  humistrtitle:string="";
  yAxislist=[];
  thdata: Thdata = new Thdata();
  StartTime: string;
  EndTime: string;
  list=[];
  strtitle:string="";

  async getPage() {
    //filters
    //debugger;
    //let ss=this.value;
    this.pagerequest.AddTime=this.AddTime;
    this.pagerequest.mac=this.mac;
    this.list=await this.$store.dispatch({
      type: "thdata/getPagedLast",
      data: this.pagerequest,
    });
    //console.log(this.list);
    //this.ThisThPaged();
    this.strtitle='温度走势图';
    this.humistrtitle='湿度走势图';
    let titlelist = ["一号针", "二号针", "三号针"];

    this.serieslist.push(
      {
        name: "一号针",
        type: "line",
        data: [],
        markPoint: {
          data: []
          },
      },
      {
        name: "二号针",
        type: "line",
        data: [],
        markPoint: {
          data: []
          },
      },
      {
        name: "三号针",
        type: "line",
        data: [],
        markPoint: {
          data: []
          },
      }
    );
    this.humiserieslist.push(
      {
        name: "一号针",
        type: "line",
        data: [],
        markPoint: {
          data: []
          },
      },
      {
        name: "二号针",
        type: "line",
        data: [],
        markPoint: {
          data: []
          },
      },
      {
        name: "三号针",
        type: "line",
        data: [],
        markPoint: {
          data: []
          },
      }
    );

    let timelist = [];
    // for (let i = 0; i < 24; i++) {
    //   timelist.push(i.toString() + ":00");
    // }

    let datalist_temp1 = [];
    let datalist_humi1 = [];
    let datalist_temp2 = [];
    let datalist_humi2 = [];
    let datalist_temp3 = [];
    let datalist_humi3 = [];
    let point_temp1 = [];
    let point_temp2 = [];
    let point_temp3 = [];
    let point_humi1 = [];
    let point_humi2 = [];
    let point_humi3 = [];


    //console.log(this.ThisThPaged);
    //console.log(this.ThisThList);
    for (let entry of this.list) {
      if(entry.pNo==1){
        timelist.push(this.GetMinutes(entry.addTime));
        datalist_temp1.push(entry.temp);
        datalist_humi1.push(entry.humi);
         if(entry.temp > this.maxtemp || entry.temp < this.mintemp){
          point_temp1.push({ value: entry.temp,xAxis: this.GetMinutes(entry.addTime),yAxis:entry.temp});
        }
        if(entry.humi > this.maxhumi || entry.humi < this.minhumi){
          point_humi1.push({ value: entry.humi,xAxis: this.GetMinutes(entry.addTime),yAxis:entry.humi});
        }
      }else if(entry.pNo==2){
        datalist_temp2.push(entry.temp);
        datalist_humi2.push(entry.humi);
        if(entry.temp > this.maxtemp || entry.temp < this.mintemp){
          point_temp2.push({ value: entry.temp,xAxis: this.GetMinutes(entry.addTime),yAxis:entry.temp});
        }
        if(entry.humi > this.maxhumi || entry.humi < this.minhumi){
          point_humi2.push({ value: entry.humi,xAxis: this.GetMinutes(entry.addTime),yAxis:entry.humi});
        }
      }else if(entry.pNo==3){
        datalist_temp3.push(entry.temp);
        datalist_humi3.push(entry.humi);
        if(entry.temp > this.maxtemp || entry.temp < this.mintemp){
          point_temp3.push({ value: entry.temp,xAxis: this.GetMinutes(entry.addTime),yAxis:entry.temp});
        }
        if(entry.humi > this.maxhumi || entry.humi < this.minhumi){
          point_humi3.push({ value: entry.humi,xAxis: this.GetMinutes(entry.addTime),yAxis:entry.humi});
        }
      }
      
    }

    this.serieslist[0].data = datalist_temp1;
    this.serieslist[1].data = datalist_temp2;
    this.serieslist[2].data = datalist_temp3;
    this.serieslist[0].markPoint.data = point_temp1;
    this.serieslist[1].markPoint.data = point_temp2;
    this.serieslist[2].markPoint.data = point_temp3;

    this.humiserieslist[0].data = datalist_humi1;
    this.humiserieslist[1].data = datalist_humi2;
    this.humiserieslist[2].data = datalist_humi3;
    this.humiserieslist[0].markPoint.data = point_humi1;
    this.humiserieslist[1].markPoint.data = point_humi2;
    this.humiserieslist[2].markPoint.data = point_humi3;

    this.legenddata = JSON.stringify(titlelist);
    this.seriesdata = JSON.stringify(this.serieslist);
    this.humiseriesdata = JSON.stringify(this.humiserieslist);
    this.xAxisdata = JSON.stringify(timelist);
    this.showEcharts();
  }
 GetMinutes(time) {
  //  console.log(time);
    let date = new Date(time);
    let Str = this.GetBqMinutes(date.getHours()) + ":" + this.GetBqMinutes(date.getMinutes());
    return Str;
  }
  GetBqMinutes(str){
    if(str.toString().length==1){
      return '0'+str;
    }
    return str;
  }
  visibleChange(value: boolean) {

    // this.ThisThPaged();

    if (!value) {
      this.$emit("input", value);
    } else {
      // this.thdata = Util.extend(
      //   true,
      //   {},
      //   this.$store.state.thdata.analyseThdata
      // );
      //console.log(this.$store.state.thdata.analyseThdata);
      this.getPage();
    }
    
  }

  cancel() {
    //this.getPage();
    this.$emit("input", false);
  }

  showEcharts() {
    this.componentKey += 1;
    this.componentKeyhumi+=1;
  }

  // async ThisThPaged(){
  //  this.list=await this.$store.dispatch({
  //     type:"thdata/getThisThPaged",
  //   });
  //   //return this.list;
    
  // }

 
}
